<template>
    <div class="my-5 pt-sm-3">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="text-center">
              <div class="row justify-content-center mt-2">
                <div class="col-sm-4">
                  <div class="maintenance-img">
                    <lottie :options="defaultOptions"/>
                  </div>
                </div>
              </div>
              <h4 class="mt-3 mb-3">{{ $t('components.no-subscription.title') }}</h4>
              <h6 class="text-muted">
                <span v-html="$t('components.no-subscription.text')"></span>
              </h6>

              <div class="row justify-content-center mt-5">
                <div class="col-md-8">
                  <b-btn variant="primary" pill @click="redirectPricing">
                    <i class="mdi mdi-plus-circle"></i>
                    {{ $t('components.no-subscription.btn') }}
                  </b-btn>
                </div>
                <!-- end col-->
              </div>
              <!-- end row-->
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Lottie from "vue-lottie";
import noSubscription from '@/assets/animations/no-subscription.js'
export default {
  name: 'NoSubscriptionComponent',
  components: {Lottie},
  data() {
    return {
      defaultOptions: {animationData: noSubscription, loop: false},
    };
  },
  methods: {
    redirectPricing() {
      this.$router.push({name: 'pricing'})
    }
  }
};
</script>
